import { useState } from "react";
import { queries } from "../../../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";
import { SettingsCard, SettingsHeading, SettingsRow } from "../../SettingsCard";
import { Text } from "../../Text";
import { Toggle } from "../../Toggle";
import { PrimaryChangeModal } from "./SsoProviderChanges";

export function PrimaryProviderField({
  providerId,
  isOn,
  onToggle,
}: {
  providerId: string;
  isOn: boolean;
  onToggle: (replaceConfirmed: boolean) => void;
}) {
  const [providers] = useQuery(queries.ssoProviders());
  const [replacing, setReplacing] = useState<string | null>(null);
  const current = providers.find(
    (p) => p.isPrimary && p.providerId !== providerId.trim()
  )?.providerId;

  return (
    <SettingsCard>
      <SettingsRow>
        <SettingsHeading>
          <Text variant="text-regular-md">Use for tenant sign-in</Text>
          <Text variant="text-small" color="var(--text-secondary)">
            Routes that pick this provider directly can use it either way.
          </Text>
        </SettingsHeading>
        <Toggle
          isOn={isOn}
          onToggle={() => {
            if (!isOn && current) setReplacing(current);
            else onToggle(false);
          }}
          ariaLabel="Use for tenant sign-in"
        />
      </SettingsRow>
      {replacing !== null && (
        <PrimaryChangeModal
          providerId={providerId.trim()}
          isPrimary
          confirmLabel="Replace"
          replacing={replacing}
          onCancel={() => setReplacing(null)}
          onConfirm={() => {
            setReplacing(null);
            onToggle(true);
          }}
        />
      )}
    </SettingsCard>
  );
}
